import { render, staticRenderFns } from "./AsociarCampos.vue?vue&type=template&id=73b60ca8&"
import script from "./AsociarCampos.vue?vue&type=script&lang=ts&"
export * from "./AsociarCampos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('73b60ca8', component.options)
    } else {
      api.reload('73b60ca8', component.options)
    }
    module.hot.accept("./AsociarCampos.vue?vue&type=template&id=73b60ca8&", function () {
      api.rerender('73b60ca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/DescargaActividades/crud/crear/AsociarCampos.vue"
export default component.exports